import { routes } from '#router/routes';
import { computed } from 'vue';
import { usePermissions } from './usePermissions';

export function useMarketShareDashboardLink() {
  const permissions = usePermissions();

  const marketShareLink = computed(() =>
    permissions.hasAccessToNielsenMarketShare ? routes.detail('market-share').path : undefined
  );

  return { marketShareLink };
}
